import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useFilePicker } from 'use-file-picker';
import { save } from 'save-file';
import {
  FileAmountLimitValidator,
  FileTypeValidator,
  FileSizeValidator,
  ImageDimensionsValidator,
} from 'use-file-picker/validators';
//import { Document, Page, pdfjs } from 'react-pdf';

import 'bootstrap/dist/css/bootstrap.min.css';
import './static/bootstrap.min.css'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { number } from 'yup';
import { BorderWidth } from 'react-bootstrap-icons';



/*  
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
  ).toString();
  */

import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ShowB64doc = ({ content }) => {
  const [numPages, setNumPages] = useState();
  const [page, setPage] = useState(1);

  if (page > numPages) {
    setPage(1);
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  if (content.length < 100) {
    return null;
  }
  return (
    <div>
      <div style={{ borderColor: 'black', borderWidth: '1px', borderStyle: 'solid' }}>
        <Document file={content}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page pageNumber={page}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            customTextRenderer={false} />
        </Document>
      </div>
      <Row style={{ marginTop: '-00px' }}>
        <Col>
          <Button
            variant="secondary"
            disabled={page == 1}
            onClick={() => setPage(page - 1)}
          >&lt;</Button>
        </Col>
        <Col>
          <p>{page} av {numPages}</p>
        </Col>
        <Col>
          <Button
            variant="secondary"
            disabled={page == numPages}
            onClick={() => setPage(page + 1)}
          >&gt;</Button>
        </Col>
      </Row>
    </div>);
};

const OnePdf = ({ file }) => {
  const [numbers, setNumbers] = useState([]);
  const [finalPdf, setFinalPdf] = useState('');
  const [skipToLine, setSkipToLine] = useState(false);
  const [numberAll, setNumberAll] = useState(false);
  const [onlyUnique, setOnlyUnique] = useState(false);
  const [preText, setPreText] = useState("Lgh: ");

  var numbersProcessed = numbers.map(s => preText + (skipToLine ? s.substring(s.lastIndexOf('-') + 1) : s));

  if (onlyUnique) {
    numbersProcessed = [...new Set(numbersProcessed)];
  }

  return <div>
    <ShowB64doc content={(file.content)} />
    <br />
    <h2>Nummer att lägga till</h2>
    <Row>
      <Col>
        <Form.Check
          inline
          label="Ta bort till Streck"
          type={"checkbox"}
          id={"Ta bort till sträck"}
          style={{ marginLeft: '30px' }}
          onChange={e => setSkipToLine(!skipToLine)}
        />
      </Col>
      <Col>
        <Form.Check
          inline
          label="Numrera alla sidor"
          type={"checkbox"}
          id={"Numrera alla"}
          style={{ marginLeft: '30px' }}
          onChange={e => setNumberAll(!numberAll)}
        />
      </Col>
      <Col>
        <Form.Check
          inline
          label="Ta bort dubbletter"
          type={"checkbox"}
          id={"Dubbletter"}
          style={{ marginLeft: '30px' }}
          onChange={e => setOnlyUnique(!onlyUnique)}
        />
      </Col>
    </Row>
    <span>Text innan nummer </span>
    <input
      label="Numrera alla sidor"
      type="text" onChange={e =>
        setPreText(e.target.value)
      } value={preText} />
    <Row>
      <Col>
        <textarea placeholder={"1\n2\n3\n..."} cols={10} rows={20} onChange={(e => setNumbers(e.target.value.replace("\r", "").split('\n')))}></textarea>
      </Col>
      <Col>
        <ul>
          {numbersProcessed.map((n, i) => <li key={i}>{n}</li>)}
        </ul>
      </Col>
    </Row>

    <br />

    <Button onClick={() => {
      fetch("/pdf", {
        method: 'POST',
        body: JSON.stringify({
          file: file.content,
          numbers: numbersProcessed,
          numberAll: numberAll,
        })
      })
        .then(r => r.text())
        .then(t => {
          setFinalPdf(t);
        });
    }}
      disabled={numbers.length == 0}
      style={{ marginBottom: '40px' }}
    >
      Numrera
    </Button>
    <br />

    <ShowB64doc content={"data:application/pdf;base64," + finalPdf} />
    {finalPdf.length > 100 ?
      <Button
        style={{ marginBottom: '40px' }}
        onClick={e => save("data:application/pdf;base64," + finalPdf, "Numrerade-" + file.name)}>
        Spara</Button> : null
    }
  </div>;
};


const Body = () => {
  const { openFilePicker, filesContent, loading } = useFilePicker({
    accept: '.pdf',
    readAs: 'DataURL',
    multiple: false,
    validators: [
      new FileAmountLimitValidator({ max: 1 }),
      new FileTypeValidator(['pdf']),
      new FileSizeValidator({ maxFileSize: 50 * 1024 * 1024 /* 50 MB */ }),
    ],
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  return (<div style={{
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: 'white',
    paddingTop: '30px',
    borderRadius: '10px',
    textAlign: 'center',
    minHeight: '300px'
  }}>
    <h2>Välj pdf att numrera!</h2>
    <div key={"wrap"}>
      <Button key={"button"} onClick={() => openFilePicker()}>Välj PDF!</Button>

      {filesContent.length > 1 ? <p>För många filer valda</p> : null}
      {filesContent.length == 1 ? <OnePdf file={filesContent[0]} /> : null}
    </div>
  </div>
  );
}


ReactDOM.createRoot(document.getElementById("root")).render(
  <div className="root" style={{ backgroundImage: 'linear-gradient(to bottom right, #999999, white)', minHeight: '100vh' }}>
    <Body />
  </div>
);

